<template>
    <div class="loan-detail">
        <b-form role="form" class="mt-4">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Loan Amount (RM)">
                      <b-input-group  :prepend="'RM'">
												<b-form-input
														v-model="form.loan_amount"
														type="number"
														maxlength="15"
														:min="min_loan_amount"
														placeholder="Loan Amount (RM)"
														step="0.01"
														:disabled="is_readonly"
												>
												</b-form-input>
											</b-input-group>	
											<small v-if="(min_loan_amount > 0)" class="text-danger">Some disbursement has approved, minimum loan allowed is RM {{ min_loan_amount | moneyFormatter}}</small>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Interest per Annum (%)">
											<b-input-group  :append="'%'">
												<b-form-input
														v-model="form.interest_rate"
														type="number"
														maxlength="5"
														placeholder="Interest per Annum (%)"
														step="0.01"
														:disabled="is_readonly"
												>
												</b-form-input>
											</b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-loading="_gHlp.isEmpty(filteredLoanTypes)">
									  <b-form-group label="Loan Type">
											<b-form-select v-model="form.loan_type_id" :disabled="is_readonly" @change="selectLoanType($event)">
												<b-form-select-option v-for="item in filteredLoanTypes" :key="item.id" :label="item.name"
													:value="item.id">{{
														item.name }}</b-form-select-option>
											</b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Tenure Period">
											<b-input-group  :append="form.loan_tenure_period">
													<b-form-input
															v-model="form.loan_tenure"
															type="number"
															maxlength="1"
															step="1"
															placeholder="Tenure Period"
															:disabled="is_readonly"
													>
													</b-form-input>
											</b-input-group>
										</b-form-group>
                </b-col>
                <!-- <b-col md="8" cols="12" class="d-flex align-items-center mb-4">
                    <b-form-checkbox
                        v-model="form.short_term"
                        class="mr-5"
                        value="true"
                        unchecked-value="false"
                    >Short Term Loan</b-form-checkbox>
                    <b-form-checkbox
                        v-model="form.factoring"
                        value="true"
                        unchecked-value="false"
                    >Factoring Loan</b-form-checkbox>
                </b-col> -->
                <b-col cols="12">
									<div class="d-flex align-items-center my-2">
										<div>
											<el-switch style="display: block" v-model="form.use_moratorium"
												active-color="#099A78" :active-value="1" :inactive-value="0" @change="setUseMoratorium($event)"
												:disabled="is_readonly">
											</el-switch>
										</div>
										<div class="ml-2">
											<strong>Use Moratorium</strong>
										</div>
									</div>
								</b-col>
                <b-col cols="12" v-if="form.use_moratorium == 1">
                    <b-form-group label="Moratorium Eligible Rate (%)">
                        <b-form-input
                            v-model="form.moratorium_rate"
                            type="number"
                            maxlength="2"
                            placeholder="Moratorium Eligible Rate (%)"
														step="0.01"
														:disabled="is_readonly"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12"  v-if="form.use_moratorium == 1">
                    <b-form-group label="Moratorium Tenure (Months)">
                        <b-form-input
                            v-model="form.moratorium_tenure"
                            type="number"
                            step="1"
                            placeholder="Moratorium Tenure"
														:disabled="is_readonly"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Loan Agreement Approved Date">
                        <el-date-picker
                        v-model="form.loan_approved_date"
												value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="Pick a day"
												:disabled="is_readonly"
                        ></el-date-picker>
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="12">
                    <b-form-group label="Repayment First Due Date">
                        <el-date-picker
                        v-model="form.repay_first_due_date"
												value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="Pick a day"
												:disabled="is_readonly"
                        ></el-date-picker>
                    </b-form-group>
                </b-col> -->
                <b-col cols="12" class="text-right" v-if="!is_readonly">
                    <el-button class="bg-warning text-white px-5" @click.prevent="showCalculation()" :loading="is_loading">View Calculation</el-button>
                    <el-button class="bg-primary text-white px-5" @click.prevent="updateAll()" :loading="is_loading">Submit For Approval</el-button>
                </b-col>
            </b-row>
        </b-form>
				<ModalCaseCalculator ref="modal_case_calculator"/>
    </div>
</template>
<script>
import { DatePicker, Button, Switch } from 'element-ui'
import {cloneDeep, isEqual} from 'lodash'
import { swal } from '@/assets/js/httpImports.js';
import CurrencyInput from '@/components/CurrencyInput'
import ModalCaseCalculator from '@/views/CreditLoanCase/Modals/ModalCaseCalculator'
import { calculateRule78, calculateFactoryLoan, calculateShortTermLoan, calculateLoanEligibility, calculateFlexiLoan } from '@/assets/js/calculator';
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { mapState,mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import { useApprovalStore } from '@/stores/approvalStore'
import { useMessagingStore } from '@/stores/messagingStore';
import { useNotificationStore } from '@/stores/notificationStore';

export default {
		props:['loanTypes','is_readonly'],
    components: {
        CurrencyInput,
				ModalCaseCalculator,
        [Switch.name]: Switch,
        [Button.name]: Button,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            form: {
								loan_amount:'',
                loan_type_id:'',
								interest_rate:'',
								loan_tenure_period:'',
								loan_tenure:'',
								use_moratorium:0,
								moratorium_rate:'',
								moratorium_start:'',
								moratorium_tenure:'',
								loan_approved_date:'',
								// repay_first_due_date:'',
								// total_interest_amt:'',
								// total_instalment_amt:'',
								// installment_amount:'',
								// arrangement_fee_amt:'',
								// arrangement_sst_prc:'',
								// admin_fee_amt:'',
								// stamping_fee_prc:'',
								// legal_fee_prc:'',
								// legal_fee_amt:'',
								// legal_sst_prc:'',
								// legal_cost_amt:'',
            },
            adv_available_months: [0, 1, 2, 3, 4, 5],
            periods: ["Months","Years"],
						is_loading:false
        }
    },
		computed: {
			...mapState(useLoanCaseStore, ['activeDisbursements','activeCase']),
			filteredLoanTypes(){
				return !_gHlp.isEmpty(this.loanTypes) ? this.loanTypes.filter(item => item['code'] !== 'ML') : [];
			},
			min_loan_amount(){
				let total = 0;
				if (!_gHlp.isEmpty(this.activeDisbursements)) {
					total = this.activeDisbursements.reduce((tot, obj) => {
						return (obj.status == 'Approved') ? (tot + parseFloat(obj.amount)) : tot
					}, 0)
				}
				return parseFloat(total).toFixed(2);
			}
		},
		watch: {
			'activeCase': {
				handler(newValue, oldValue) {
					this.setForm(cloneDeep(newValue))
				},
				immediate: true
			}
  	},
    methods: {
			...mapActions(useLoanCaseStore, ['updateCase']),
			...mapActions(useApprovalStore, ['createApproval']),
			...mapActions(useNotificationStore, ['createBellNotif']),
			...mapActions(useMessagingStore, ['createSendEmail']),
			preventNonNumericInput,
			setForm(data){
				this.form.loan_amount = data.loan_amount;
				this.form.loan_type_id = data.loan_type_id;
				this.form.interest_rate = data.interest_rate;
				this.form.loan_tenure = data.loan_tenure;
				this.form.loan_tenure_period = data.loan_tenure_period;
				this.form.use_moratorium = data.use_moratorium;
				this.form.moratorium_tenure = data.moratorium_tenure;
				this.form.moratorium_rate = data.moratorium_rate;
				this.form.moratorium_start = data.moratorium_start;
				this.form.moratorium_inst = data.moratorium_inst;
				this.form.loan_approved_date = data.loan_approved_date;
				// this.form.repay_first_due_date = data.repay_first_due_date;
			},
			selectLoanType(id){
				const loanType = this.filteredLoanTypes.find(itm => itm.id == id);
				this.form.loan_tenure_period = _gHlp.getValue(loanType,'loan_tenure_period','Years')
			},
			setUseMoratorium(show){
				if(show == 1){
					this.form.moratorium_tenure = _gHlp.getValue(this.activeCase,'moratorium_tenure',0);
					this.form.moratorium_rate = _gHlp.getValue(this.activeCase,'moratorium_rate',50);
					this.form.moratorium_start = _gHlp.getValue(this.activeCase,'moratorium_start',1);
					this.form.moratorium_inst = _gHlp.getValue(this.activeCase,'moratorium_inst',0);
				}else{
					this.form.moratorium_tenure = 0;
					this.form.moratorium_rate = 50;
					this.form.moratorium_start = 1;
					this.form.moratorium_inst = 0;
				}
				const loanType = this.filteredLoanTypes.find(itm => itm.id == this.form.loan_type_id);
				this.form.loan_tenure_period = _gHlp.getValue(loanType,'loan_tenure_period','Years')
			},
			getParams(item) {
				if(_gHlp.isEmpty(item)) return {}

				return {
					loan_amount: parseFloat(item.loan_amount).toFixed(2),
					loan_type_id: item.loan_type_id,
					interest_rate: parseFloat(item.interest_rate),
					loan_tenure_period: item.loan_tenure_period,
					loan_tenure: item.loan_tenure,
					use_moratorium: item.use_moratorium,
					moratorium_rate: item.moratorium_rate,
					moratorium_tenure: item.moratorium_tenure,
					loan_approved_date: item.loan_approved_date,
					// repay_first_due_date: item.repay_first_due_date
				}
			},
			updateAll(){
				const newData = this.getParams(this.form)	
				const oldData = this.getParams(this.activeCase);
				if(isEqual(newData, oldData)){
					_gNotif.notifySuccess('Please update something',1000, 'warning');
					return false;
				}
				const calculateSumm = this.calcLoanCalculator()
				const repayment_breakdown = _gHlp.getValue(calculateSumm, 'loan_table',[]);
				
				let params = {
					...newData,
					total_interest_amt: parseFloat(_gHlp.getValue(calculateSumm, 'total_interest',0)).toFixed(2),
					installment_amount: parseFloat(_gHlp.getValue(calculateSumm, 'installment',0)).toFixed(2),
					total_instalment_amt: (parseFloat(newData.loan_amount) + parseFloat(_gHlp.getValue(calculateSumm, 'total_interest',0))).toFixed(2),
					loan_tenure_year: ((newData.loan_tenure_period == 'Years') ? newData.loan_tenure : newData.loan_tenure / 12),
					moratorium_inst: parseFloat(_gHlp.getValue(calculateSumm, 'moratorium_installment', 0)),
					moratorium_start: parseInt(_gHlp.getValue(calculateSumm, 'moratorium_start_period', 0))
				}
				if(!_gHlp.isEmpty(repayment_breakdown)){
					params['repayment_breakdown'] = repayment_breakdown
				}
				
				// this.updateCase(params).then(res => {
				// 	if(params.use_approval == 1) {
				// 		_gNotif.notifySuccess("Case loan changes has been submitted for approval", )
				// 	}else{
				// 		_gNotif.notifySuccess("Case loan detail has been update")
				// 	}
				// 	this.is_loading = false;
				// });
				this.submitForApproval(params)
			},
			showCalculation(){
				const newData = this.getParams(this.form)	
				const calculateSumm = this.calcLoanCalculator()
				const repayment_breakdown = _gHlp.getValue(calculateSumm, 'loan_table',[]);
				
				let params = {
					...newData,
					total_interest_amt: parseFloat(_gHlp.getValue(calculateSumm, 'total_interest',0)).toFixed(2),
					installment_amount: parseFloat(_gHlp.getValue(calculateSumm, 'installment',0)).toFixed(2),
					total_instalment_amt: (parseFloat(newData.loan_amount) + parseFloat(_gHlp.getValue(calculateSumm, 'total_interest',0))).toFixed(2),
					loan_tenure_year: ((newData.loan_tenure_period == 'Years') ? newData.loan_tenure : newData.loan_tenure / 12),
					moratorium_inst: parseFloat(_gHlp.getValue(calculateSumm, 'moratorium_installment', 0)),
					moratorium_start: parseInt(_gHlp.getValue(calculateSumm, 'moratorium_start_period', 0)),
					repayment_breakdown: repayment_breakdown,
				}
				
				this.$refs.modal_case_calculator.show(params)
			},
			calculateLoan(data, loanType) {
				// console.log(` Loan Type: `, loanType);
				// Check loan type and call corresponding function
				if (loanType.code === 'FL') {
					// Factory loan
					return calculateFactoryLoan(data, loanType);
				} else if (loanType.loan_tenure_period === 'Years' && loanType.interest_rate_period === 'Years') {
					// Rule 78 loan
					return calculateRule78(data, loanType);
				} else if ((loanType.loan_tenure_period === 'Months' && loanType.interest_rate_period === 'One Time') || loanType.code === 'FEL') {
					// Short term loan
					return calculateShortTermLoan(data, loanType);
				} else {
					// Invalid loan type
					return null;
				}
			},
			calcLoanCalculator() {
				const loanType = this.filteredLoanTypes.find(itm => itm.id == this.form.loan_type_id)
				if(_gHlp.isEmpty(loanType)) return {};

				let loanData = {
							...this.form
						}						
						
				let data = {
					loan_amount: parseFloat(_gHlp.getValue(loanData, 'loan_amount', 0)),
					loan_tenure: parseInt(_gHlp.getValue(loanData, 'loan_tenure', 0)),
					interest_rate: parseFloat(_gHlp.getValue(loanData, 'interest_rate', 0)),
				};

				if (_gHlp.getValue(loanData, 'use_moratorium', 0) == 1) {
						data['moratorium_tenure'] = parseInt(_gHlp.getValue(loanData, 'moratorium_tenure', 0))
						data['moratorium_eligible_rate'] = parseFloat(_gHlp.getValue(loanData, 'moratorium_rate', 0))
						data['moratorium_start_period'] = parseInt(_gHlp.getValue(loanData, 'moratorium_start', 0))
					}
			
				let result = this.calculateLoan(data, loanType);
				// if (!_gHlp.isEmpty(result)) {
				// 	let totalDebtConsole = 0
				// 	if(!_gHlp.isEmpty(this.activeDisbursements)){
				// 		totalDebtConsole = this.activeDisbursements.reduce((tot, obj) => {
				// 													if(!_gHlp.isEmpty(obj.amount) && (tot.description != 'Balance Disbursement')){
				// 														return tot + parseFloat(obj.amount)
				// 													}else{
				// 														return tot
				// 													}
				// 												}, 0)
				// 	}

				// 	// let currDisBalances = this.activeDisbursements.find(itm => itm.description == 'Balance Disbursement');
				// 	// let newItems = [];
				// 	// if(!_gHlp.isEmpty(currDisBalances) && currDisBalances.status != 'Approved'){
				// 	// 	newItems.push(currDisBalances)
				// 	// }	
				// 	// result['newDisbursements'] = _gHlp.patchData(this.activeDisbursements,newItems,'description');
				// }

				return result;
			},
			submitForApproval(changeData){
				swal.fire({
					title: 'Detail Change',
					text: "Submit to credit head for approval changes",
					showCancelButton: true,
					confirmButtonColor: '#13663E',
					cancelButtonColor: '#8898aa',
					confirmButtonText: 'Submit',
					reverseButtons: true,
					customClass: {
						title: 'text-left',
						container: 'text-left',
						htmlContainer: 'text-left',
						actions: 'w-100 pr-4 justify-content-end'
					}
				}).then((result) => {
					if (result.isConfirmed) {
						this.is_loading = true;
						const params = {
							table_name: 'loan_case',
							table_key: 'case_id',
							table_id: this.activeCase.case_id,
							data_reject: null,
							data_approve: changeData,
							message: 'Pending Approval : Case detail has been change by credit officer ' + _gAuth.activeUser('name', ''),
							approve_type: 'Case Detail Approval',
							custom_key: 'CASE_' + this.activeCase.case_id,
							approve_status: 'Pending',
							submit_at: _gHlp.getCurrentDateTime(),
							submit_by: _gAuth.activeUser('id', null)
						}
						this.createApproval(params).then(res => {
							this.createBellNotif('LMS_CASE_UPDATE_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
							this.createSendEmail('LMS_CASE_UPDATE_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
							gEventBus.$emit('refresh-approval')
							gEventBus.$emit('close_edit_case')
							_gNotif.notifySuccess('<b>Case Detail: </b> - new case detail data has been submitted for approval', 1000, 'success');
							this.is_loading = false;
						}).catch(err => {
							this.is_loading = false;
						});
					}
				})
			}
    }
}
</script>